import React, { useContext, useEffect } from "react";
import { Link } from "react-router-dom";
import { files } from "../configs";
import { Context } from "../GlobalContext";
import "../global/pages.css";
import "./Greeting.css";

const Greeting = ({ history }) => {
  const { token, userData, reqInfoPages, firstSurvType } = useContext(Context);

  useEffect(() => {
    if (reqInfoPages.needsAgree) {
      history.replace(`/token/${token}/confirm`);
    }
  }, [reqInfoPages]);

  return (
    <div className="container" id="greeting__container">
      <div className="logo" id="greeting__logo">
        <img src={userData.gov.logoUrl} alt="state logo" />
      </div>
      <div id="greeting__content">
        <img
          src={userData.gov.introduction}
          alt="아동이 살기 좋은 우리 동네 만들기"
        />
      </div>
      <div className="next-button">
        <Link
          to={
            reqInfoPages.needsAgree
              ? `/token/${token}/confirm`
              : reqInfoPages.needsInfoOne
              ? `/token/${token}/info-1`
              : reqInfoPages.needsInfoTwo
              ? `/token/${token}/info-2`
              : `/token/${token}/intro/${firstSurvType}/0/0/0`
          }
          className="btn big-btn"
          alt="시작하기 버튼"
        >
          <span>시작하기</span>
        </Link>
      </div>
      <div className="notice-wrap">
        <div className="notice">
          <img
            src={
              "https://tsukuru-inquiry-backend.s3.ap-northeast-2.amazonaws.com/images/info.svg"
            }
            alt="info"
          />
          <span>
            진행과 관련하여 궁금한 점은 {userData.customNum}으로 연락 하십시오.
            아동참여 플랫폼 관련 궁금한 점이 있다고 말씀하시면 담당자가 친절히
            안내해 드리겠습니다.
            <br />
            (안내시간 | 주중 09:00~18:00)
          </span>
        </div>
        <div className="notice">
          <img src={files + "/chrome.svg"} alt="크롬 브라우저" />
          <span>
            본 웹사이트는 크롬 브라우저에 최적화되어있습니다.
            <br />
            <a
              href="https://www.google.com/intl/ko/chrome/"
              target="_blank"
              rel="noopener noreferrer"
            >
              크롬 브라우저 다운받기
            </a>
          </span>
        </div>
      </div>
    </div>
  );
};

export default Greeting;
